/* eslint-disable react-hooks/rules-of-hooks */
/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
/* eslint-disable no-unused-expressions */

import React, { useState, useEffect, useContext, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Form, Formik, Field } from 'formik';
import * as yup from 'yup';
import Layout from 'components/Layout';
import BrokingSummary from 'components/BrokingSummary';
import Button, { ButtonContainer } from 'components/Button';
import ContentCard from 'components/ContentCard';
import FileModal from 'components/FileModal';
import TextField from 'components/Form/TextField';
import DialogComponent from 'components/Dialog';
import { TextEditorBox } from 'components/index';
import { GlobalLoaderContext } from 'store/context';
import { GlobalAuthContext } from 'store/context';
import { FitinsurAPI, MessageCenter } from 'utils';
import { Scrollbox, ButtonContent, DialogConfirm, Textarea, DialogRejected, ContentTextarea } from './styles';
import StepNavigation from 'components/StepNavigation/index';
import RenderButtons from 'components/RenderButtons';
import HasPermission from 'components/HasPermission/index';
import { useHeaderNbi, useDocument, useAproveNbiReq } from 'services/QuoteService'; 

export default function NbiAprovalCv(props) {

  const loading = useContext(GlobalLoaderContext);
  const [isBound, setIsBound] = useState(false);
  const [summary, setSummary] = useState({})
  const [file, setFile] = useState();
  const formik = useRef(null);

  const history = useHistory();
  const [historymsg, setHistorymsg] = useState([]);
  const authContext = useContext(GlobalAuthContext);
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const isClient = authContext.enumProfile === 1 ? true : false;

  const {
    data: useHeaderNbiData,
    loading: useHeaderNbiLoading,
    error: useHeaderNbiError,
    status: useHeaderNbiStatus,
    request: useHeaderNbiRequest,
  } = useHeaderNbi();

  const {
    data: useDocumentData,
    loading: useDocumentLoading,
    error: useDocumentError,
    status: useDocumentStatus,
    request: useDocumentRequest,
  } = useDocument();

  const {
    data: useAproveNbiReqData,
    loading: useAproveNbiReqLoading,
    error: useAproveNbiReqError,
    status: useAproveNbiReqStatus,
    request: useAproveNbiReqRequest,
  } = useAproveNbiReq();

  useEffect(() => {
    if (useHeaderNbiLoading || useDocumentLoading || useAproveNbiReqLoading) {
      loading.start();
    } else {
      loading.stop();
    }
  }, [useHeaderNbiLoading, useDocumentLoading, useAproveNbiReqLoading]);

  const goToLoginPage = () => {
    history.push('/login');
  };

  function handleHistoryMessage() {
    let tempmessage = "";
    if (historymsg?.length >= 1) {
      historymsg.map(
        (message, index) => {
          const tempMsg = `[${index + 1}] - Name: ${message.userFullName}, Date: ${message.approvalDate}
            ${message.approvalComments}
      
              `;
          tempmessage = (tempmessage + tempMsg);
        }
      )
      return tempmessage;
    }
  };

  useEffect(() => {
    let v = handleHistoryMessage()
    if (formik.current) {
      formik.current?.setFieldValue('dealAnalisysInformation', v)

    }

  }, [historymsg])

  function handleFile() {
    useDocumentRequest({idOperation: props.match.params.idOperation, idTemplate: 4}, null).then((a) => {
      if (a.status !== 200) {
            mc.error(`There was an error while fetching your data: ${handleFile.name}\n`);
            history.goBack();
            return;
        } else {          
            setFile(a.data);
        }
      }).catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleFile.name}\n` + error);
      });
  };

  function handleSummary() {
    useHeaderNbiRequest({idOperation: props.match.params.idOperation}, null).then(({data}) => {
      if (data.ret_code != 200) {
          mc.error(data.ret_msg_details);
          history.goBack();
          return;
        }
        setSummary({
          typeOfCover: data.ret_value.typeOfCover,
          client: data.ret_value.client,
          obligorCoding: data.ret_value.obligorCoding,
          responseBy: data.ret_value.responseBy,
          internalContact: data.ret_value.internalContact,
          broker: data.ret_value.broker,
          dealCode: data.ret_value.deal,
          nmFacility: data.ret_value.nmFacility,
          nmObligor: data.ret_value.nmObligor,
          projectName: data.ret_value.projectName,
          idDomainStatusNbi: data.ret_value.idDomainStatusNbi,
          idOperation: props.match.params.idOperation,
        });
        setHistorymsg(data.ret_value.historical);

        if (formik.current) {
          formik.current?.setFieldValue('nbiClientSubjectMessage', data.ret_value.nbiClientSubjectMessage || '');
          formik.current?.setFieldValue('additionalNbiClientSubjectivity', data.ret_value.additionalNbiClientSubjectivity || '');
        }
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleSummary.name}\n` + error);
      });
  };

  function handleAproval() {
    useAproveNbiReqRequest({idOperation: props.match.params.idOperation, txtAnswerOption: userComments, sendEmail: true}, null).then(({data: resp}) => {
        if (resp.ret_code === 200) {
          if (isClient) {
            history.push(`/list`);
          } else {
            if (resp.ret_value && resp.ret_value.idDomainStatus === 20) {
              history.push(`/broking/document-nbi-status/${props.match.params.idOperation}`, { idProduct: props.location.state.idProduct });
            } else {
              history.push(`/broking/send-nbi-cv/${props.match.params.idOperation}`, { idProduct: props.location.state.idProduct });
            }
          }

        } else {
          mc.error(resp.ret_msg_details);
          return;
        }
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleAproval.name}\n` + error);
      });
  };

  async function handleReject() {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestRejectNbiReq(props.match.params.idOperation, userComments)
      .then(x => x.json()).then(resp => {
        if (resp.ret_code === 200) {
          mc.success("NBI Request Rejected");
          props.history.push('/list');
        } else {
          mc.error(resp.ret_msg_details);
          return;
        }
      }).catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleReject.name}\n` + error);
      });
  };

  const [userComments, setUserComments] = useState(null);
  const [typeDialog, setTypeDialog] = useState(null);
  const [dialog, setDialog] = useState({
    visible: false,
    title: '',
    icon: 'exclamation',
    args: null
  });

  function handleCancel() {
    setUserComments("");
    setDialog({
      visible: false,
      title: '',
      icon: 'exclamation',
      args: null
    })
  }

  function handleDialog(type) {
    if (type === "Approve") {
      setTypeDialog("Approve");
      setDialog({
        visible: true,
        title: "APPROVE NBI",
        icon: "TimesCircle",
        args: null,
      })
    } else {
      setTypeDialog("Reject");
      setDialog({
        visible: true,
        title: "REJECT NBI",
        icon: "TimesCircle",
        args: null,
      })
    }
  };

  useEffect(() => {
    fitinsur.setAuthToken(authContext.token);
    
    handleFile();
    handleSummary();
  }, []);

  const validation = yup.object().shape({});

  return (
    <Layout idOperation={props.match?.params?.idOperation} title={summary.projectName ? summary.projectName : summary?.nmObligor ? summary?.nmObligor : "Broking name"} subtitle={summary?.dealCode ? summary?.dealCode : "Deal Code"}>
      <StepNavigation stage={2} idOperation={props.match?.params?.idOperation} />
      <Scrollbox>
        <BrokingSummary data={summary} />
        <ContentCard title="APPROVAL NBI" icon info={{ idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null }}>
          <DialogComponent icon={dialog.icon} title={dialog.title}  show={dialog.visible} setDialog={setDialog}>
            {typeDialog === 'Approve' ?
              <ContentTextarea>
                <p>Deal Analysis information</p>
                <Textarea value={userComments} onChange={(e) => setUserComments(e.target.value)}></Textarea>
                <DialogRejected onClick={() => handleCancel()}>CANCEL</DialogRejected>
                <DialogConfirm onClick={() => handleAproval()}>CONFIRM</DialogConfirm>
              </ContentTextarea>

              : typeDialog === 'Reject' ?
                <ContentTextarea>
                  <p>Deal Analysis information</p>
                  <Textarea value={userComments} onChange={(e) => setUserComments(e.target.value)}></Textarea>
                  <DialogRejected type="submit" onClick={() => handleCancel()}>CANCEL</DialogRejected>
                  <DialogConfirm type="submit" onClick={() => handleReject()}>CONFIRM</DialogConfirm>
                </ContentTextarea>
                : ''
            }
          </DialogComponent>{ }

          <Formik
            innerRef={formik}
            initialValues={{
              nbiClientSubjectMessage: '',
              additionalNbiClientSubjectivity: '',
              dealAnalisysInformation: ''

            }}
            validationSchema={validation}
            onSubmit={() => { }}
          >
            {formikProps => (
              <Form>
                <TextEditorBox
                  label="NBI Message - (External)"

                  name="nbiClientSubjectMessage"
                  initialValue={formikProps.values.nbiClientSubjectMessage}
                  disabled
                />

                <Field
                  readOnly
                  label='Additional subjectivities or questions'
                  name='additionalNbiClientSubjectivity'
                  value={formikProps.values.additionalNbiClientSubjectivity}
                  onChange={(e) => formikProps?.setFieldValue('additionalNbiClientSubjectivity', e)}
                  component={TextField}
                />

                <FileModal idOperation={props?.match?.params?.idOperation} file={file} />
                {!isClient ? (
                  <Field
                    readOnly
                    label={'Deal Analysis Information'}
                    name={'dealAnalisysInformation'}
                    value={formikProps.values.dealAnalisysInformation}
                    onChange={(e) => formikProps?.setFieldValue('dealAnalisysInformation', e)}
                    component={TextField}
                  />

                ) : ''}
                <HasPermission permission={(summary.idDomainStatusNbi === 16 || summary.idDomainStatusNbi === 19) && props.permissions.NBI_APPROVE_REJECT}>
                  <ButtonContainer>
                    <Button forth onClick={() => history.goBack()}>&lt; Back</Button>
                    <HasPermission permission={!isBound}>
                      <RenderButtons idOperation={props.match?.params?.idOperation}>
                        <ButtonContent>
                          <Button secundary onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleDialog("Reject") }} style={{ marginLeft: "10px", marginTop: "5px" }}>
                            REJECT
                          </Button>
                          <Button primary onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleDialog("Approve") }} style={{ marginLeft: "10px", marginTop: "5px" }}>
                            APPROVE
                          </Button>
                        </ButtonContent>
                      </RenderButtons>
                    </HasPermission>
                  </ButtonContainer>
                </HasPermission>
              </Form>
            )}
          </Formik>
        </ContentCard>
      </Scrollbox>
    </Layout >
  )
}
